import {
  IonList,
  IonListHeader,
  IonLabel,
  IonText,
  IonCard,
  IonItem,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import { checkmarkCircleOutline, timeOutline } from "ionicons/icons";
import { useSelector } from "react-redux";
import { selectPaymentNotice } from "../../../store/paymentNoticeDetail/selectors/selectPaymentNotice";
import currencyFormat from "../../../utils/currencyFormat";

export const InvoiceSummary: React.FC = () => {
  const paymentNotice = useSelector(selectPaymentNotice);

  return (
    <>
      <IonList>
        <IonListHeader>
          <IonLabel>
            <p>
              <IonText color="tertiary">
                {(paymentNotice.reconciliations?.length || 0) > 1 && (
                  <span>
                    Se han pagado{" "}
                    <strong>
                      {paymentNotice.reconciliations?.length || 0}
                    </strong>{" "}
                    documentos con el abono
                  </span>
                )}

                {(paymentNotice.reconciliations?.length || 0) === 1 && (
                  <span>
                    Se ha pagado <strong>1</strong> documento con el abono
                  </span>
                )}
              </IonText>
            </p>
          </IonLabel>
        </IonListHeader>
        {paymentNotice.reconciliations?.map((paymentReconciliationItem) => (
          <IonCard key={paymentReconciliationItem.id}>
            <IonItem lines="full">
              <IonLabel>
                <IonText>
                  <strong>Factura</strong>
                </IonText>
              </IonLabel>
            </IonItem>
            <IonRow>
              <IonCol size="6" class="ion-no-padding">
                <IonItem lines="none">
                  <IonLabel>
                    <p>Nº Documento</p>
                    <IonText>
                      <strong>
                        #{paymentReconciliationItem.invoice?.identifier}
                      </strong>
                    </IonText>
                  </IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="6" class="ion-no-padding">
                <IonItem lines="none">
                  <IonLabel>
                    <p>Vencimiento</p>
                    <strong>
                      {paymentReconciliationItem.invoice?.expiresAtLegible}
                    </strong>
                  </IonLabel>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6" class="ion-no-padding">
                <IonItem lines="none">
                  <IonLabel>
                    <p>Monto factura</p>
                    <strong>
                      {currencyFormat(
                        paymentReconciliationItem.invoice?.amount || 0
                      )}
                    </strong>
                  </IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="6" class="ion-no-padding">
                <IonItem lines="none" class="ion-margin-bottom">
                  {paymentReconciliationItem.amount !==
                    paymentReconciliationItem.invoice?.amount && (
                    <IonLabel>
                      <p>Monto abonado</p>
                      <strong>
                        {currencyFormat(paymentReconciliationItem.amount || 0)}
                      </strong>
                    </IonLabel>
                  )}
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6" class="ion-no-padding">
                <IonItem lines="none" class="ion-margin-bottom">
                  {(paymentReconciliationItem.invoice?.amount || 0) -
                  (paymentReconciliationItem.invoice?.payedAmount || 0) ? (
                    <IonLabel>
                      <p>Estado</p>
                      <IonText color="warning">
                        <IonIcon
                          icon={timeOutline}
                          class="ion-margin-end"
                        ></IonIcon>
                        <strong>Pendiente</strong>
                      </IonText>
                    </IonLabel>
                  ) : (
                    <IonLabel>
                      <p>Estado</p>
                      <IonText color="success">
                        <IonIcon
                          icon={checkmarkCircleOutline}
                          class="ion-margin-end"
                        ></IonIcon>
                        <strong>Pagada</strong>
                      </IonText>
                    </IonLabel>
                  )}
                </IonItem>
              </IonCol>
            </IonRow>
          </IonCard>
        ))}
      </IonList>
    </>
  );
};
